import Cookies from "js-cookie";

/**
 * Kya browser ke paas koi session token pada hai?
 *
 * Iska matlab "logged in" nahi hai — sirf itna ki server se profile poochhne
 * ka koi matlab banta hai. Isse do fayde:
 *  - anonymous visitor ke home page par ek bekaar 401 request nahi jaati
 *  - private route pata kar sakta hai ki "role abhi nahi hai" ka matlab
 *    "logged out" hai ya "profile abhi load ho rahi hai"
 *
 * Token wahin se padha jaata hai jahan rtkAPI.ts prepareHeaders padhta hai.
 */
export const hasStoredSession = (): boolean => {
  try {
    if (localStorage.getItem("jwt")) return true;
  } catch {
    /* private mode / storage blocked */
  }
  try {
    if (Cookies.get("jwt")) return true;
  } catch {
    /* ignore */
  }
  return false;
};

export default hasStoredSession;
